import umalqura from "@umalqura/core";

import { addIstDays, toIst } from "@/lib/time";

import type { HijriDate, HijriOffset } from "./types";

const MONTH_NAMES_EN = [
  "Muharram",
  "Safar",
  "Rabi' al-Awwal",
  "Rabi' al-Thani",
  "Jumada al-Awwal",
  "Jumada al-Thani",
  "Rajab",
  "Sha'ban",
  "Ramadan",
  "Shawwal",
  "Dhul Qa'dah",
  "Dhul Hijjah",
];

const MONTH_NAMES_AR = [
  "محرم",
  "صفر",
  "ربيع الأول",
  "ربيع الآخر",
  "جمادى الأولى",
  "جمادى الآخرة",
  "رجب",
  "شعبان",
  "رمضان",
  "شوال",
  "ذو القعدة",
  "ذو الحجة",
];

const WEEKDAY_EN = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday (Jumu'ah)",
  "Saturday",
];

const WEEKDAY_AR = [
  "الأحد",
  "الاثنين",
  "الثلاثاء",
  "الأربعاء",
  "الخميس",
  "الجمعة",
  "السبت",
];

export function toHijri(referenceUtc: Date, offset: HijriOffset = 0): HijriDate {
  const shifted = offset === 0 ? referenceUtc : addIstDays(referenceUtc, offset);
  const ist = toIst(shifted);
  const um = umalqura(ist);
  const monthIdx = um.hm - 1;
  const weekdayIdx = ist.getDay();

  return {
    day: um.hd,
    month: um.hm,
    year: um.hy,
    monthName: MONTH_NAMES_EN[monthIdx] ?? "",
    monthNameAr: MONTH_NAMES_AR[monthIdx] ?? "",
    weekday: WEEKDAY_EN[weekdayIdx] ?? "",
    weekdayAr: WEEKDAY_AR[weekdayIdx] ?? "",
  };
}
